// src/components/ThemeToggle.js
import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  const handleToggle = (newTheme) => {
    toggleTheme(newTheme);
  };

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-app-text dark:text-app-text">
        Appearance
      </h3>
      <p className="text-sm text-app-text-secondary dark:text-app-text-secondary">
        Choose your preferred theme for the app
      </p>

      <div className="flex gap-3 mt-4">
        {/* Light Theme Option */}
        <button
          onClick={() => handleToggle('light')}
          className={`
            flex-1 flex items-center justify-center py-3 px-4 rounded-lg border-2 transition-all
            ${
              theme === 'light'
                ? 'border-app-accent bg-app-accent/10'
                : 'border-app-border dark:border-app-border hover:border-app-accent/50'
            }
          `}
          aria-pressed={theme === 'light'}
        >
          <span
            className={`text-sm font-medium ${
              theme === 'light'
                ? 'text-app-accent'
                : 'text-app-text dark:text-app-text'
            }`}
          >
            Light
          </span>
        </button>

        {/* Dark Theme Option */}
        <button
          onClick={() => handleToggle('dark')}
          className={`
            flex-1 flex items-center justify-center py-3 px-4 rounded-lg border-2 transition-all
            ${
              theme === 'dark'
                ? 'border-app-accent bg-app-accent/10'
                : 'border-app-border dark:border-app-border hover:border-app-accent/50'
            }
          `}
          aria-pressed={theme === 'dark'}
        >
          <span
            className={`text-sm font-medium ${
              theme === 'dark'
                ? 'text-app-accent'
                : 'text-app-text dark:text-app-text'
            }`}
          >
            Dark
          </span>
        </button>
      </div>

      {/* Current Selection Indicator */}
      <p className="text-xs text-app-text-secondary dark:text-app-text-secondary text-center mt-2">
        Current theme: <span className="font-semibold capitalize">{theme}</span>
      </p>
    </div>
  );
};

export default ThemeToggle;
